import baseApi from "./baseApiEndpoints";
import {FETCH_USER, ORGANIZATION, PASSWORD_RESET, PASSWORD_UPDATE, USER_BASE} from "../../helpers/constants/url";
//https://github.com/wix/pro-gallery
// Define a service using a base URL and expected endpoints
export const accountApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    organizationUpdate: builder.mutation({
      query: (payload) => ({
        url: `${ORGANIZATION}${payload.get("owner")}/`,
        method: "PATCH",
        body: payload,
      }),
      providesTags: ["Organization"],
      invalidatesTags: ["Me"]
    }),
    userUpdate: builder.mutation({
      query: (payload) => ({
        url: `${FETCH_USER}`,
        method: "PATCH",
        body: payload,
      }),
      providesTags: ["User"],
      invalidatesTags: ["Me"]
    }),
    passwordUpdate: builder.mutation({
      query: (payload) => ({
        url: `${PASSWORD_UPDATE}`,
        method: "POST",
        body: payload,
      }),
    }),
    passwordReset: builder.mutation({
      query: (payload) => ({
        url: `${PASSWORD_RESET}`,
        method: "POST",
        body: payload,
      }),
    })
  }),
  overrideExisting: false,
});

export const { useOrganizationUpdateMutation, useUserUpdateMutation, usePasswordUpdateMutation, usePasswordResetMutation } = accountApi;